import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import {
  Modal,
  Stack,
  Text,
  Center,
  Button,
  Loader,
  Image,
} from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";
import {
  IconPlus,
  IconArrowDown,
  IconArrowsUpDown,
  IconApps,
} from "@tabler/icons-react";
import { TextWithInfo } from "./textWithInfo";
import ConnectionCard from "../interactiveData/connectionCard";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const ConnectApps = observer(({ cubby }: { cubby: Cubby }) => {
  const [showConnectionOptions, setShowConnectionOptions] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    cubby.refreshNostrConnections();
  }, []);

  const connections = cubby.nostrConnectionsOrderedByCreatedAtDesc;

  const handleNewConnectionClick = () => {
    setShowConnectionOptions(!showConnectionOptions);
  };

  const createConnection = async (
    type: "receive_only" | "send_and_receive"
  ) => {
    setLoading(true);
    setTimeout(() => {
      if (type === "receive_only") {
        cubby.cubbyFastInfo("make_new_receive_only_nwc_connection");
      } else {
        cubby.cubbyFastInfo("make_new_send_and_receive_nwc_connection");
      }
      setLoading(false);
      setShowConnectionOptions(false);
    }, 6000);
  };

  return (
    <Modal
      opened={cubby.currentModal === MODALS.CONNECT_APPS}
      onClose={() => cubby.setModal(null)}
      title={
        <TextWithInfoAndIcon
          text="Connect Apps"
          articleSlug={ARTICLES.NWC_SEND_AND_RECEIVE.slug}
          icon={<IconApps size={24} />}
          cubby={cubby}
          textSize="lg"
        />
      }
    >
      {/* Show a full-page loader until there is at least one connection */}
      {connections.length === 0 ? (
        <Center style={{ height: "100%" }}>
          <Loader size="lg" />
        </Center>
      ) : (
        <Stack gap="md">
          <Center>
            <Image
              w={200}
              src="https://daxwktpz4hkwd.cloudfront.net/nwc_logos/nwc-horizontal-with-text-color.png"
              alt="NWC Logo"
            />
          </Center>
          <Text>
            You can send and receive payments using external apps with{" "}
            <strong>Nostr Wallet Connect</strong>. This is experimental
            technology. Please only use this with apps and websites that you
            trust.
          </Text>

          {connections.length > 12 && (
            <Text>
              You've reached the maximum number of connections. Please delete an
              existing connection to add a new one.
            </Text>
          )}
          {showConnectionOptions && !loading && <Stack gap="xs"></Stack>}

          {loading && (
            <Center mt="md">
              <Loader size="md" />
            </Center>
          )}

          {connections.map((connection) => (
            <ConnectionCard
              key={connection.uuid}
              connection={connection}
              cubby={cubby}
            />
          ))}
          {!loading && connections.length <= 12 && (
            <Center mt="md">
              <Button
                leftSection={<IconArrowsUpDown />}
                variant="default"
                onClick={() => createConnection("send_and_receive")}
              >
                New Send & Receive Connection
              </Button>
              {/* <Text size="sm" c="dimmed">
                Only share this with apps you trust.
              </Text> */}
            </Center>
          )}
        </Stack>
      )}
    </Modal>
  );
});

export default ConnectApps;
